import React, { useState } from "react";
import classes from "./fileupload.module.scss";
import { FiPlus } from "react-icons/fi";
import { Controller } from "react-hook-form";

const FileUploader = ({ name, control, fileInfo, setFileInfo }) => {
  const handleUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFileInfo(file);
    }
  };

  return (
    <div className={classes.wrapper}>
      <label className={classes.wrapper__btn}>
        <input
          type="file"
          id="fileUpload"
          name={name}
          onChange={handleUpload}
        />
        <FiPlus />
        <span>Upload File</span>
      </label>

      {fileInfo && (
        <span className={classes.wrapper__fileName}>{fileInfo.name}</span>
      )}
    </div>
  );
};

export default FileUploader;
